import React from "react";

const SvgVilla = (props) => (
  <svg
    width="31"
    height="31"
    viewBox="0 0 31 31"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity="0.5">
      <g clip-path="url(#clip0_328_2008)">
        <path
          d="M15.5 0.96875H11.625C11.4965 0.96875 11.3733 1.01978 11.2825 1.11062C11.1917 1.20146 11.1406 1.32466 11.1406 1.45312V2.42188C11.1406 2.55034 11.1917 2.67354 11.2825 2.76438C11.3733 2.85522 11.4965 2.90625 11.625 2.90625H12.1094V3.875H15.0156V2.90625H15.5C15.6285 2.90625 15.7517 2.85522 15.8425 2.76438C15.9333 2.67354 15.9844 2.55034 15.9844 2.42188V1.45312C15.9844 1.32466 15.9333 1.20146 15.8425 1.11062C15.7517 1.01978 15.6285 0.96875 15.5 0.96875Z"
           fill="currentColor"
        />
        <path
          d="M22.0299 2.27656L15.2486 10.1879C15.0982 10.3632 15.0154 10.5865 15.0151 10.8175C15.0152 11.0155 15.076 11.2086 15.1891 11.371C15.3023 11.5334 15.4625 11.6572 15.6482 11.7258C15.8338 11.7944 16.0361 11.8044 16.2276 11.7546C16.4192 11.7048 16.5909 11.5976 16.7197 11.4472L22.7656 4.39522L28.8111 11.4482C28.9399 11.5986 29.1116 11.7059 29.3032 11.7556C29.4949 11.8054 29.6971 11.7953 29.8828 11.7267C30.0685 11.658 30.2287 11.5341 30.3418 11.3717C30.455 11.2092 30.5156 11.016 30.5156 10.818C30.5154 10.587 30.4326 10.3637 30.2822 10.1883L23.5014 2.27656C23.4104 2.17038 23.2976 2.08514 23.1706 2.02669C23.0436 1.96825 22.9054 1.93799 22.7656 1.93799C22.6258 1.93799 22.4877 1.96825 22.3607 2.02669C22.2337 2.08514 22.1208 2.17038 22.0299 2.27656Z"
          fill="currentColor"
        />
        <path
          d="M30.0312 28.0938H0.96875C0.701237 28.0938 0.484375 28.3106 0.484375 28.5781V29.5469C0.484375 29.8144 0.701237 30.0312 0.96875 30.0312H30.0312C30.2988 30.0312 30.5156 29.8144 30.5156 29.5469V28.5781C30.5156 28.3106 30.2988 28.0938 30.0312 28.0938Z"
          fill="currentColor"
        />
        <path
          d="M4.84377 4.84375C4.71532 4.84378 4.59214 4.89483 4.50132 4.98567L2.56382 6.92317C2.49595 6.99106 2.44979 7.07758 2.43118 7.17175C2.41258 7.26592 2.42237 7.3635 2.45933 7.4521C2.49628 7.54069 2.55872 7.61631 2.63873 7.66935C2.71874 7.72239 2.8127 7.75046 2.9087 7.75H16.0619L18.5516 4.84375H4.84377Z"
          fill="currentColor"
        />
        <path
          d="M2.90627 15.5C2.77782 15.5 2.65464 15.5511 2.56382 15.6419L0.626321 17.5794C0.558453 17.6473 0.512287 17.7338 0.493682 17.828C0.475077 17.9222 0.484873 18.0198 0.521827 18.1083C0.55878 18.1969 0.621224 18.2726 0.701233 18.3256C0.781241 18.3786 0.875205 18.4067 0.971196 18.4062H15.9844V15.5H2.90627Z"
          fill="currentColor"
        />
        <path
          d="M7.75 10.6562H11.625V12.5938H7.75V10.6562Z"
          fill="currentColor"
        />
        <path
          d="M14.0469 10.8175C14.0474 10.3557 14.2126 9.90915 14.5128 9.55817L15.2317 8.71875H4.35938V14.5312H15.9844V12.757C15.4708 12.7551 14.9788 12.5501 14.6158 12.1867C14.2528 11.8233 14.0483 11.3312 14.0469 10.8175ZM12.5938 13.0781C12.5938 13.2066 12.5427 13.3298 12.4519 13.4206C12.361 13.5115 12.2378 13.5625 12.1094 13.5625H7.26562C7.13716 13.5625 7.01396 13.5115 6.92312 13.4206C6.83228 13.3298 6.78125 13.2066 6.78125 13.0781V10.1719C6.78125 10.0434 6.83228 9.92021 6.92312 9.82937C7.01396 9.73853 7.13716 9.6875 7.26562 9.6875H12.1094C12.2378 9.6875 12.361 9.73853 12.4519 9.82937C12.5427 9.92021 12.5938 10.0434 12.5938 10.1719V13.0781Z"
          fill="currentColor"
        />
        <path
          d="M10.6562 21.7969H13.5625V24.7031H10.6562V21.7969Z"
          fill="currentColor"
        />
        <path
          d="M4.84375 21.7969H7.75V24.7031H4.84375V21.7969Z"
          fill="currentColor"
        />
        <path
          d="M2.42188 19.375V27.125H15.9844V19.375H2.42188ZM8.71875 25.1875C8.71875 25.316 8.66772 25.4392 8.57688 25.53C8.48604 25.6208 8.36284 25.6719 8.23438 25.6719H4.35938C4.23091 25.6719 4.10771 25.6208 4.01687 25.53C3.92603 25.4392 3.875 25.316 3.875 25.1875V21.3125C3.875 21.184 3.92603 21.0608 4.01687 20.97C4.10771 20.8792 4.23091 20.8281 4.35938 20.8281H8.23438C8.36284 20.8281 8.48604 20.8792 8.57688 20.97C8.66772 21.0608 8.71875 21.184 8.71875 21.3125V25.1875ZM14.5312 25.1875C14.5312 25.316 14.4802 25.4392 14.3894 25.53C14.2985 25.6208 14.1753 25.6719 14.0469 25.6719H10.1719C10.0434 25.6719 9.92021 25.6208 9.82937 25.53C9.73853 25.4392 9.6875 25.316 9.6875 25.1875V21.3125C9.6875 21.184 9.73853 21.0608 9.82937 20.97C9.92021 20.8792 10.0434 20.8281 10.1719 20.8281H14.0469C14.1753 20.8281 14.2985 20.8792 14.3894 20.97C14.4802 21.0608 14.5312 21.184 14.5312 21.3125V25.1875Z"
          fill="currentColor"
        />
        <path
          d="M22.7656 11.625C22.3802 11.625 22.0106 11.7781 21.7381 12.0506C21.4656 12.3231 21.3125 12.6927 21.3125 13.0781V15.5H24.2188V13.0781C24.2188 12.6927 24.0657 12.3231 23.7931 12.0506C23.5206 11.7781 23.151 11.625 22.7656 11.625Z"
          fill="currentColor"
        />
        <path
          d="M20.8281 21.3125H24.7031V27.125H20.8281V21.3125Z"
          fill="currentColor"
        />
        <path
          d="M22.7656 5.88373L16.9531 12.665V27.125H19.8594V20.8281C19.8594 20.6997 19.9104 20.5765 20.0012 20.4856C20.0921 20.3948 20.2153 20.3438 20.3438 20.3438H25.1875C25.316 20.3438 25.4392 20.3948 25.53 20.4856C25.6208 20.5765 25.6719 20.6997 25.6719 20.8281V27.125H28.5781V12.665L22.7656 5.88373ZM25.1875 15.9844C25.1875 16.1129 25.1365 16.2361 25.0456 16.3269C24.9548 16.4177 24.8316 16.4688 24.7031 16.4688H20.8281C20.6997 16.4688 20.5765 16.4177 20.4856 16.3269C20.3948 16.2361 20.3438 16.1129 20.3438 15.9844V13.0781C20.3438 12.4358 20.5989 11.8198 21.0531 11.3656C21.5073 10.9114 22.1233 10.6563 22.7656 10.6563C23.4079 10.6563 24.024 10.9114 24.4781 11.3656C24.9323 11.8198 25.1875 12.4358 25.1875 13.0781V15.9844Z"
          fill="currentColor"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_328_2008">
        <rect width="31" height="31" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgVilla;
